import { LinearMipMapLinearFilter, RawShaderMaterial, Texture } from 'three';
import appEnvironment from '../../../../simple-flow/app-environment';
import fontFactory from '../../../font-factory/font-factory';
import textFragmentShader from '../../shaders/text_fragment_shader.glsl';
import textVertexShader from '../../shaders/text_vertex_shader.glsl';

import {
    FONT_COLOR_THRESHOLD,
    FONT_UBUFFER_DARK,
    FONT_UBUFFER_LIGHT,
    FONT_UGAMMA,
} from '../../../../constants/render-constants';

const threeFontFactory = ({ fontDefinition, imageData }) => {
    let _material;

    const font = fontFactory({ colorNormalized: true, fontDefinition });

    const _initMaterial = () => {
        const texture = new Texture();

        texture.minFilter = LinearMipMapLinearFilter;
        if (!appEnvironment.getVar('testing')) {
            const tmpImage = new Image();

            tmpImage.src = imageData;

            texture.image = tmpImage;
            tmpImage.onload = function () {
                texture.needsUpdate = true;
            };
        }
        _material = new RawShaderMaterial({
            fragmentShader: textFragmentShader,
            transparent: true,
            vertexShader: textVertexShader,
        });
        _material.depthTest = false;
        _material.depthWrite = false;

        _material.uniforms.uSampler = { type: 't', value: texture };
        _material.uniforms.uBufferDark = { value: FONT_UBUFFER_DARK };
        _material.uniforms.uBufferLight = { value: FONT_UBUFFER_LIGHT };
        _material.uniforms.uColorThreshold = { value: FONT_COLOR_THRESHOLD };
        _material.uniforms.uGamma = { value: FONT_UGAMMA };
    };

    _initMaterial();

    const getMaterial = () => _material;

    const setGamma = (gamma) => {
        _material.uniforms.uGamma = { value: gamma };
    };

    const addText = (params) => font.addText(params);

    return {
        addText,
        getMaterial,
        setGamma,
    };
};

export default threeFontFactory;
